import { render, staticRenderFns } from "./ModelNewHeader.vue?vue&type=template&id=f0ceea02&scoped=true&"
import script from "./ModelNewHeader.vue?vue&type=script&lang=js&"
export * from "./ModelNewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModelNewHeader.vue?vue&type=style&index=0&id=f0ceea02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ceea02",
  null
  
)

export default component.exports